import Vue from "vue";
import VueRouter from "vue-router";

import Home from "../views/Home.vue";
import Login from "../views/Login.vue";
import ForgotPassword from "../views/ForgotPassword.vue";
import Register from "../views/Register.vue";
import Profile from "../views/Profile.vue";
import Dashboard from "../views/Dashboard.vue";
import Saviour from "../views/Saviour.vue";
import OrderNow from "../views/OrderNow.vue";
import DiscoArea from "../views/DiscoArea.vue";
import ProjectLog from "../views/ProjectLog.vue";
import OrderNowStatic from "../views/OrderNowStatic.vue";
import Cart from "../views/Cart.vue";
import RestaurantAnimatedModal from "../components/RestaurantAnimatedModal.vue";
import OrderNowInfiniteScroll from "../views/OrderNowInfiniteScroll.vue";
import FetchOrder from "../views/FetchOrder.vue";
import ConfirmAndAccept from "../views/ConfirmAndAccept.vue";
import OrderSummary from "../views/OrderSummary.vue";
import Error404 from "../views/Error404.vue";
import Confirmed from "../views/Confirmed";
import Tasks from "../views/Tasks.vue";
import DeliveredTheOrder from "../views/DeliveredTheOrder.vue";
import AdminView from "../views/AdminView.vue";
import SaviourTermsAndConditions from "../views/SaviourTermsAndConditions.vue";

import firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
    meta: {
      title: "Home",
      requiresAuthentication: false,
    },
  },
  {
    path: "*",
    name: "Error404",
    component: Error404,
    meta: {
      title: "Error 404",
      requiresAuthentication: false,
    },
  },
  {
    path: "/admin-view-secret-no-one-knows",
    name: "AdminView",
    component: AdminView,
    meta: {
      title: "Admin View",
      requiresAuthentication: true,
      requiresAdmin: true,
    },
  },
  {
    path: "/login",
    name: "Login",
    component: Login,
    meta: {
      title: "Login",
      requiresAuthentication: false,
    },
  },
  {
    path: "/register",
    name: "Register",
    component: Register,
    meta: {
      title: "Register",
      requiresAuthentication: false,
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      title: "Forgot Password",
      requiresAuthentication: false,
    },
  },
  {
    path: "/profile",
    name: "Profile",
    component: Profile,
    meta: {
      title: "Profile",
      requiresAuthentication: true,
    },
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    component: Dashboard,
    meta: {
      title: "Dashboard",
      requiresAuthentication: true,
    },
  },
  {
    path: "/order-now",
    name: "OrderNow",
    component: OrderNow,
    meta: {
      title: "Order Now",
      requiresAuthentication: true,
    },
  },
  {
    path: "/saviour",
    name: "Saviour",
    component: Saviour,
    meta: {
      title: "Saviour Mode",
      requiresAuthentication: true,
    },
  },
  {
    path: "/project-log",
    name: "ProjectLog",
    component: ProjectLog,
    meta: {
      title: "Project Log",
      requiresAuthentication: false,
    },
  },
  {
    path: "/order-now-old",
    name: "OrderNowStatic",
    component: OrderNowStatic,
    meta: {
      title: "Order Now Old View",
    },
  },

  {
    path: "/order-now-inf",
    name: "OrderNowInfiniteScroll",
    component: OrderNowInfiniteScroll,
    meta: {
      title: "Order Now Infinite Scroll",
    },
  },
  {
    path: "/order-summary",
    name: "OrderSummary",
    component: OrderSummary,
    meta: {
      title: "Order Summary",
      requiresAuthentication: true,
    },
  },
  {
    path: "/cart",
    name: "Cart",
    component: Cart,
    meta: {
      title: "Cart",
      requiresAuthentication: true,
    },
  },
  {
    path: "/fetch-order",
    name: "FetchOrder",
    component: FetchOrder,
    meta: {
      title: "Fetch Order",
      requiresAuthentication: true,
    },
  },
  {
    path: "/animated-restaurant-modal",
    name: "RestaurantAnimatedModal",
    component: RestaurantAnimatedModal,
    meta: {
      title: "RestaurantAnimatedModal",
    },
  },
  {
    path: "/disco-area",
    name: "DiscoArea",
    component: DiscoArea,
    meta: {
      title: "DiscoArea",
      requiresAuthentication: true,
    },
  },
  {
    path: "/confirm-and-accept/:orderId",
    name: "ConfirmAndAccept",
    component: ConfirmAndAccept,
    props: true,
    meta: {
      title: "Confirm And Accept The Order",
      requiresAuthentication: true,
    },
  },
  {
    path: "/confirmed/:orderId",
    name: "Confirmed",
    component: Confirmed,
    props: true,
    meta: {
      title: "Order Confirmed",
      requiresAuthentication: true,
    },
  },
  {
    path: "/tasks",
    name: "Tasks",
    component: Tasks,
    meta: {
      title: "Tasks",
      requiresAuthentication: true,
    },
  },
  {
    path: "/delivered-the-order",
    name: "DeliveredTheOrder",
    component: DeliveredTheOrder,
    meta: {
      title: "Order Delivered",
      requiresAuthentication: true,
    },
  },
  {
    path: "/saviour-terms-and-conditions",
    name: "SaviourTermsAndConditions",
    component: SaviourTermsAndConditions,
    meta: {
      title: "Terms And Conditions For Saviour",
      requiresAuthentication: true,
    },
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  document.title = `${to.meta.title} | SOS`;
  next();
});

router.beforeEach(async (to, from, next) => {
  let user = firebase.auth().currentUser;
  /*
  let admin = null;

  if (user) {
    let token = await user.getIdTokenResult();
    admin = token.claims.admin;
  }
*/
  if (to.matched.some((res) => res.meta.requiresAuthentication)) {
    if (user) {
      /*
      if (to.matched.some((res) => res.meta.requiresAdmin)) {
        if (admin) {
          return next();
        }
        return next({ name: "Dashboard" });
      }
      */
      return next();
    }
    //this.$toast("Kindly Login For a Smoother Experience!");
    return next({ name: "Login" });
  }
  next();
});

export default router;
